import { DirectiveBase } from '../angular-directive-base.directive';

/**
 * Provides a summary of an operator's payment information
 */
export class ActSummaryBar extends DirectiveBase {
  constructor() {
    super();
    this.restrict = 'E';
    this.scope = {
      templateName: '@',
      currentSummary: '='
    };
    this.template = '<ng-include src="vm.getTemplateUrl()"/>';
    this.controller = 'SummaryBarController';
    this.controllerAs = 'vm';
    this.bindToController = true;
  }
}